import { handleUserError } from './handleError';
import { showNotification } from './showNotification';

export function temporarilyHandleReduxEffectError(e: unknown, label: string): void {
  const err = handleUserError(e, label);
  showNotification({ type: 'error', description: err.formattedString });
}
